import { useLayoutEffect, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCoverImage } from "@utils/api/memberCenterApi";
import { useBindingContext } from "@/apps/@components/binding-context";
import { logWallpaperEvent } from "@/apps/liff/pages/campaign-wallpaper-page/wallpaperLog";

/** wallpaper 活動：在 thanks 頁停留這麼久後自動導往桌布首頁（ms）。 */
const WALLPAPER_REDIRECT_DELAY = 1500;

const ThanksPage = () => {
	const navigate = useNavigate();
	const { from } = useBindingContext();
	const [paddingClass, setPaddingClass] = useState("");
	const [titleClass, setTitleClass] = useState("");
	const [descriptionClass, setDescriptionClass] = useState("");
	const [imageClass, setImageClass] = useState("");
	const [buttonClass, setButtonClass] = useState("");
	const [coverImageUrl, setCoverImageUrl] = useState(null);
	const [isLoadingCoverImage, setIsLoadingCoverImage] = useState(true);

	const goToProfilePage = () => {
		navigate("/profile");
	};

	// wallpaper 活動：綁定成功進 thanks 後，停留 1.5 秒自動導往桌布首頁
	useEffect(() => {
		if (from !== "wallpaper") return;
		const timer = setTimeout(() => {
			// 綁定完成 → 自動導回桌布首頁
			logWallpaperEvent({
				category: "system",
				path: "/wallpaper/member_bind_success",
				action: "to_home",
				event: "auto_redirect",
			});
			navigate("/wallpaper/home", { replace: true });
		}, WALLPAPER_REDIRECT_DELAY);
		return () => clearTimeout(timer);
	}, [from, navigate]);

	// 获取封面图片
	useEffect(() => {
		const fetchCoverImage = async () => {
			try {
				const result = await getCoverImage("thanks");
				if (result.image_url) {
					setCoverImageUrl(result.image_url);
				} else {
					// 如果没有获取到，使用默认图片
					setCoverImageUrl(
						window.assetUrl("/images/liff/thanks-page/cover.jpg"),
					);
				}
			} catch (error) {
				console.error("Failed to fetch cover image:", error);
				// 出错时使用默认图片
				setCoverImageUrl(window.assetUrl("/images/liff/thanks-page/cover.jpg"));
			} finally {
				setIsLoadingCoverImage(false);
			}
		};
		fetchCoverImage();
	}, []);

	useLayoutEffect(() => {
		window.addEventListener("resize", handleResize);
		handleResize();

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const handleResize = () => {
		if (window.innerWidth > 640) {
			setPaddingClass("text-center px-[30px] flex flex-col items-center");
			setTitleClass("w-[165px] h-auto mt-5");
			setDescriptionClass("w-[349px] h-auto mt-5");
			setImageClass("mt-16 h-auto w-full");
			setButtonClass("border-b pb-2 border-black w-[66px] h-auto mt-8");
		} else {
			setPaddingClass("text-center px-[5vw] flex flex-col items-center");
			setTitleClass("w-[26vw] h-auto mt-[5vw]");
			setDescriptionClass("w-[55vw] h-auto mt-[4vw]");
			setImageClass("mt-16 h-auto w-full");
			setButtonClass("border-b pb-2 border-black w-[10vw] h-auto mt-[4vw]");
		}
	};

	return (
		<div className={paddingClass}>
			<img
				alt={"title"}
				className={titleClass}
				src={window.assetUrl("/images/liff/thanks-page/title.png")}
			/>
			<img
				alt={"description"}
				className={descriptionClass}
				src={window.assetUrl("/images/liff/thanks-page/description.png")}
			/>
			{!isLoadingCoverImage && (
				<img
					alt={"cover"}
					className={imageClass}
					src={
						coverImageUrl || window.assetUrl("/images/liff/thanks-page/cover.jpg")
					}
				/>
			)}

			<div onClick={goToProfilePage}>
				<img
					alt={"profile-button"}
					className={buttonClass}
					src={window.assetUrl("/images/liff/thanks-page/profile-button.png")}
				/>
			</div>
		</div>
	);
};

export default ThanksPage;
